import { allStatuses } from '@utils/helpers';
import React, { FC } from 'react';
import InfoTooltip from '@uikit/Info/InfoTooltip/InfoTooltip';

type RenderRideStatusCellPropsType = {
  row: any;
};

export const RenderRideStatusCell: FC<RenderRideStatusCellPropsType> = ({
  row,
}) => {
  const rawStatuses = Array.isArray(row?.statusNames) ? row.statusNames : [];
  if (!rawStatuses.length) {
    return <span className="ride-status-empty">-</span>;
  }

  return (
    <div
      className="ride-status-circles"
      data-test-id="home-search-ride-status-circles"
    >
      {rawStatuses.map((statusId, index) => {
        const statusColor =
          allStatuses?.[statusId]?.backgroundColor || '#B0B0B0';
        const statusLabel = allStatuses?.[statusId]?.value || 'Unknown Status';
        const segmentNumber = index + 1;

        return (
          <InfoTooltip title={`${segmentNumber} - ${statusLabel}`}>
            <span
              key={`${statusId ?? 'status'}-${index}`}
              className="ride-status-circle"
              style={{ backgroundColor: statusColor }}
              aria-label={`${segmentNumber} - ${statusLabel}`}
            />
          </InfoTooltip>
        );
      })}
    </div>
  );
};
